import Editor from "@monaco-editor/react";
import type * as Monaco from "monaco-editor";
import { PureComponent, ReactNode } from "react";
import KuikaSwitch from "../../../ui-kit/kuika-switch/kuika-switch";
import KuikaSmallText from "../../../ui-kit/typography/SmallText/SmallText";
import {
  CODE_EDITOR_THEME,
  defineCodeEditorTheme,
  watchCodeEditorTheme
} from "../../code-editor-shell/code-editor-theme";

interface IRestApiEndpointBodyEditorProps {
  label?: string;
  fullHeight?: boolean;
  value?: string;
  showSwitch?: boolean;
  isEditable?: boolean;
  placeholder?: ReactNode;
  onChange?: (value?: string) => void;
  onEditModeChange?: (isEditable: boolean) => void;
  onValidate?: (markers: { message: string }[]) => void;
}
interface IRestApiEndpointBodyEditorState {}

export class RestApiEndpointBodyEditor extends PureComponent<
  IRestApiEndpointBodyEditorProps,
  IRestApiEndpointBodyEditorState
> {
  editorRef: any;

  codeThemeObserver: MutationObserver | undefined;

  constructor(props) {
    super(props);
  }

  componentWillUnmount(): void {
    this.codeThemeObserver?.disconnect();
  }

  /** Without a theme, mounting this editor reset every editor on the page to Monaco's light default. */
  handleEditorBeforeMount = (monacoInstance: typeof Monaco): void => {
    defineCodeEditorTheme(monacoInstance);
    this.codeThemeObserver = watchCodeEditorTheme(monacoInstance);
  };

  handleEditorOnMount = (editor) => {
    this.editorRef = editor;
  };

  render(): ReactNode {
    const { label, value, onChange, fullHeight, showSwitch, isEditable, onEditModeChange, placeholder } = this.props;

    return (
      <>
        {label && (
          <div className="kuika-connection-form__editor-header">
            <label className="kuika-form-field__label">{label}</label>
            {!isEditable && !placeholder && <KuikaSmallText>Read only</KuikaSmallText>}
            {showSwitch && !placeholder && (
              <div className="kuika-connection-form__editor-toggle">
                <KuikaSmallText>Enable editing</KuikaSmallText>
                <KuikaSwitch
                  checked={isEditable}
                  onChange={(checked: boolean) => {
                    onEditModeChange?.(checked);
                  }}
                />
              </div>
            )}
          </div>
        )}
        {placeholder || (
          <>
            <Editor
              value={value}
              options={{ readOnly: !isEditable, minimap: { enabled: false } }}
              language="json"
              theme={CODE_EDITOR_THEME}
              beforeMount={this.handleEditorBeforeMount}
              onChange={(value, _ev) => {
                if (onChange) {
                  onChange(value);
                }
              }}
              height={fullHeight ? "calc(100% - 28px)" : "calc(50% - 28px)"}
              onMount={this.handleEditorOnMount}
              onValidate={(markers) => {
                if (this.props.onValidate) this.props.onValidate(markers);
              }}
            />
          </>
        )}
      </>
    );
  }
}
